import {Component, computed, inject, input} from '@angular/core';
import {Bureau} from '../../model/bureau.model';
import {UtilisateurSigalett} from '../../../shared/models/utilisateur-sigalett.model';
import {Duree} from '../../../shared/models/duree.model';
import {TranslateService} from '@ngx-translate/core';
import {isNotNullOrUndefined} from '@sigale-angular/src/utils/functions';

export enum EtatBureau {
	INOCCUPE = 'INOCCUPE',
	INOCCUPE_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI = 'INOCCUPE_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI',
	INOCCUPE_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI = 'INOCCUPE_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI',
	RESERVE_AUTRE_UTILISATEUR_MATIN_INOCCUPE_APRES_MIDI = 'RESERVE_AUTRE_UTILISATEUR_MATIN_INOCCUPE_APRES_MIDI',
	RESERVE_UTILISATEUR_COURANT_MATIN_INOCCUPE_APRES_MIDI = 'RESERVE_UTILISATEUR_COURANT_MATIN_INOCCUPE_APRES_MIDI',
	RESERVE_UTILISATEUR_COURANT_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI = 'RESERVE_UTILISATEUR_COURANT_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI',
	RESERVE_AUTRE_UTILISATEUR_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI = 'RESERVE_AUTRE_UTILISATEUR_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI',
	RESERVE_UTILISATEUR_CONNECTE_JOURNEE = 'RESERVE_UTILISATEUR_CONNECTE_JOURNEE',
	RESERVE_AUTRE_UTILISATEUR_JOURNEE = 'RESERVE_AUTRE_UTILISATEUR_JOURNEE',
	CONFLIT = 'CONFLIT'
}

@Component({
	selector: 'app-affichage-bureau',
	templateUrl: './affichage-bureau.component.html',
	styleUrl: './affichage-bureau.component.scss'
})
export class AffichageBureauComponent {

	readonly ICONE_RESERVEE_PAR_UTILISATEUR_CONNECTE = 'pi-briefcase';
	readonly ICONE_RESERVEE = 'pi-lock';
	readonly ICONE_RESERVEE_MATIN = 'pi-sun';
	readonly ICONE_RESERVEE_APRES_MIDI = 'pi-moon';
	readonly ICONE_LIBRE_READONLY = 'pi-lock-open';
	readonly ICONE_LIBRE_PAS_READONLY = 'pi-calendar-plus';
	readonly ICONE_UTILISATEUR_PREFERENTIEL = 'pi-bookmark';
	readonly ICONE_CONFLIT = 'pi-exclamation-triangle';

	bureau = input.required<Bureau>();
	declencherHoverIndicateurBureau = input.required<boolean>();
	readonly = input.required<boolean>();
	utilisateurConnecte = input.required<UtilisateurSigalett>();
	bureauPreferentielId = input.required<number | null>();
	dureeReservationEnCours = input.required<Duree>();
	bureauIdCourant = input.required<number>();

	etatBureau = computed(() => {
		const loginUtilisateurConnecte = this.utilisateurConnecte() ? this.utilisateurConnecte().login : '';

		const estUtilisateurOccupantBureauDansLaJournee =
			this.bureauIdCourant() === this.bureau().id || this.bureau().estUtilisateurOccupantBureauSurLaJournee(loginUtilisateurConnecte);

		if (this.bureau().estReservationEnConflit() && isNotNullOrUndefined(this.bureauPreferentielId()) && this.bureau().id === this.bureauPreferentielId()) {
			return EtatBureau.CONFLIT;
		}

		if (this.bureau().reserverSeulementMatin()) {
			return estUtilisateurOccupantBureauDansLaJournee ? EtatBureau.RESERVE_UTILISATEUR_COURANT_MATIN_INOCCUPE_APRES_MIDI : EtatBureau.RESERVE_AUTRE_UTILISATEUR_MATIN_INOCCUPE_APRES_MIDI;
		}

		if (this.bureau().reserverSeulementApresMidi()) {
			return estUtilisateurOccupantBureauDansLaJournee ? EtatBureau.INOCCUPE_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI : EtatBureau.INOCCUPE_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI;
		}

		if (this.bureau().possedeDifferentsOccupantsSurJournee()) {
			if (this.bureau().estUtilisateurCourantOccupantBureauMatinee(loginUtilisateurConnecte)) {
				return EtatBureau.RESERVE_UTILISATEUR_COURANT_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI;
			}

			if (this.bureau().estUtilisateurCourantOccupantBureauApresMidi(loginUtilisateurConnecte)) {
				return EtatBureau.RESERVE_AUTRE_UTILISATEUR_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI;
			}

			return EtatBureau.RESERVE_AUTRE_UTILISATEUR_JOURNEE;
		}

		if (this.bureau().estReserveSurLaJournee() && estUtilisateurOccupantBureauDansLaJournee) {
			return EtatBureau.RESERVE_UTILISATEUR_CONNECTE_JOURNEE;
		}

		if (this.bureau().estReserveSurLaJournee() && !estUtilisateurOccupantBureauDansLaJournee) {
			return EtatBureau.RESERVE_AUTRE_UTILISATEUR_JOURNEE;
		}

		// Si on arrive ici alors, il n'y a pas de réservation
		return EtatBureau.INOCCUPE;
	});

	classePourBackgroundColorBureau = computed(() => {
		return this.readonly() ? 'readonly ' + this.etatBureau() : this.etatBureau();
	});

	iconeOccupationPourHtml = computed(() => {
		return 'pi ' + this.iconeOccupation();
	});

	iconeOccupation = computed(() => {
		switch (this.etatBureau()) {
			case 'CONFLIT': {
				return this.ICONE_CONFLIT;
			}
			case 'INOCCUPE' : {
				return this.readonly() ? this.ICONE_LIBRE_READONLY : this.ICONE_LIBRE_PAS_READONLY;
			}
			case 'RESERVE_UTILISATEUR_COURANT_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI':
			case 'RESERVE_AUTRE_UTILISATEUR_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI':
			case 'RESERVE_UTILISATEUR_CONNECTE_JOURNEE' : {
				return this.bureau().id === this.bureauPreferentielId() ? this.ICONE_UTILISATEUR_PREFERENTIEL : this.ICONE_RESERVEE_PAR_UTILISATEUR_CONNECTE;
			}
			case 'INOCCUPE_MATIN_RESERVE_UTILISATEUR_COURANT_APRES_MIDI':
			case 'INOCCUPE_MATIN_RESERVE_AUTRE_UTILISATEUR_APRES_MIDI' : {
				return this.ICONE_RESERVEE_APRES_MIDI;
			}
			case 'RESERVE_UTILISATEUR_COURANT_MATIN_INOCCUPE_APRES_MIDI':
			case 'RESERVE_AUTRE_UTILISATEUR_MATIN_INOCCUPE_APRES_MIDI' : {
				return this.ICONE_RESERVEE_MATIN;
			}
			case 'RESERVE_AUTRE_UTILISATEUR_JOURNEE' : {
				return this.ICONE_RESERVEE;
			}
		}
	});

	tooltip = computed(() => {
		const debutCleTraduction = 'RESERVER_UN_BUREAU.TOOLTIP_ICONE';

		if (this.etatBureau() === EtatBureau.INOCCUPE) {
			const cleTraductionTooltip = this.readonly() ? 'INOCCUPE_READONLY' : 'INOCCUPE_PAS_READONLY';

			return this.translateService.instant(`${debutCleTraduction}.${cleTraductionTooltip}`);
		}

		return this.translateService.instant(`${debutCleTraduction}.${this.etatBureau()}`);
	});

	private translateService = inject(TranslateService);
}
